import { useContext } from "react";
import { PatientAuth } from "./PatientAuthProvider";

export const usePatienAuthProvider = () => {
  const context = useContext(PatientAuth);

  if (context === null) {
    throw new Error(
      "usePatientProvider must be used within a PatienAuthProvider"
    );
  }

  return context;
};
